/** Google Identity Services ("Sign in with Google" button). */

interface GsiIdApi {
  initialize(config: {
    client_id: string;
    callback: (response: { credential: string }) => void;
    auto_select?: boolean;
    use_fedcm_for_prompt?: boolean;
  }): void;
  renderButton(parent: HTMLElement, options: Record<string, unknown>): void;
  disableAutoSelect(): void;
}

declare global {
  interface Window {
    google?: { accounts: { id: GsiIdApi } };
  }
}

let loading: Promise<void> | null = null;

function loadScript(): Promise<void> {
  loading ??= new Promise((resolve, reject) => {
    const s = document.createElement("script");
    s.src = "https://accounts.google.com/gsi/client";
    s.async = true;
    s.onload = () => resolve();
    s.onerror = () => {
      loading = null;
      reject(new Error("failed to load Google sign-in"));
    };
    document.head.append(s);
  });
  return loading;
}

export async function renderGoogleButton(
  container: HTMLElement,
  clientId: string,
  onCredential: (credential: string) => void,
): Promise<void> {
  await loadScript();
  const id = window.google?.accounts.id;
  if (!id) throw new Error("Google sign-in unavailable");
  id.initialize({
    client_id: clientId,
    callback: (r) => onCredential(r.credential),
    auto_select: false,
    use_fedcm_for_prompt: true,
  });
  container.replaceChildren();
  id.renderButton(container, {
    theme: "filled_blue",
    size: "large",
    shape: "pill",
    text: "continue_with",
    width: 280,
  });
}
